import './Work.css'
import React, { Component } from 'react'
import workObject from './workObject'

class Work extends Component {
	componentDidMount() {
		document.title = 'Selected Projects'
	}

	render() {
		const work = workObject.map(work => (
			<li key={work.id} className="Work-Item">
				<img src={work.image} className="Work-Image" alt={work.name} />
				<div className="Work-Details">
					<h1 className="Work-Name">{work.name}</h1>
					<p className="Work-Description"> {work.description}</p>

					<a href={work.github} target="_blank" className="Work-Project">
						<button className="btn btn-blue">Project Link</button>
					</a>

					<a href={work.source} target="_blank" className="Work-Demo">
						<button className="btn btn-green">Live Demo</button>
					</a>
				</div>
			</li>
		))
		return (
			<section className="Work">
				<ul className="Work-List">{work}</ul>
			</section>
		)
	}
}

export default Work



// WEBPACK FOOTER //
// ./src/components/Work/Work.js